import React from 'react';
import { getReportIcon } from '../helpers/reportHelpers';

const FavoriteCard = ({ report, onReportClick }) => {
  const iconName = getReportIcon(report);

  return (
    <div className="favorite-card" onClick={() => onReportClick(report)}>
      <div className="favorite-card-icon">
        <i className={`fa fa-${iconName}`}></i>
      </div>
      <div className="favorite-card-content">
        <h3 className="favorite-card-title">{report.name}</h3>
        <p className="favorite-card-description">
          {report.description || 'No description available'}
        </p>
      </div>
      <div className="favorite-card-star">
        <i className="fa fa-star"></i>
      </div>
    </div>
  );
};

export default FavoriteCard;
